import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode()
const _hoisted_3 = {
  key: 1,
  id: "is-not-federated"
}
const _hoisted_4 = { id: "dropdownContainer" }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = {
  for: "scope",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Card = _resolveComponent("Card")
  const _component_FileDataset = _resolveComponent("FileDataset")
  const _component_QueryDataset = _resolveComponent("QueryDataset")
  const _component_JavaDataset = _resolveComponent("JavaDataset")
  const _component_ScriptDataset = _resolveComponent("ScriptDataset")
  const _component_QbeDataset = _resolveComponent("QbeDataset")
  const _component_DerivedDataset = _resolveComponent("DerivedDataset")
  const _component_FlatDataset = _resolveComponent("FlatDataset")
  const _component_CkanDataset = _resolveComponent("CkanDataset")
  const _component_RestDataset = _resolveComponent("RestDataset")
  const _component_SparqlDataset = _resolveComponent("SparqlDataset")
  const _component_SolrDataset = _resolveComponent("SolrDataset")
  const _component_PythonDataset = _resolveComponent("PythonDataset")
  const _component_ParamTable = _resolveComponent("ParamTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.dataset.dsTypeCd == 'Federated')
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("label", null, _toDisplayString(_ctx.$t('managers.datasetManagement.selectDatasetType')) + ": ", 1),
          _hoisted_2,
          _createVNode("b", null, _toDisplayString(_ctx.dataset.dsTypeCd), 1)
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_Card, { class: "p-m-2" }, {
            content: _withCtx(() => [
              _createVNode("div", _hoisted_4, [
                _createVNode("span", _hoisted_5, [
                  _createVNode(_component_Dropdown, {
                    id: "scope",
                    class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.dsTypeCd.$invalid && _ctx.v$.dataset.dsTypeCd.$dirty
                            }],
                    style: _ctx.typeTabDescriptor.style.maxWidth,
                    options: _ctx.getAllowed(),
                    optionLabel: "VALUE_CD",
                    optionValue: "VALUE_CD",
                    modelValue: _ctx.v$.dataset.dsTypeCd.$model,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.dataset.dsTypeCd.$model = $event)),
                    onBeforeShow: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.dataset.dsTypeCd.$touch())),
                    onChange: _ctx.handleTypeChange,
                    disabled: _ctx.dataset.dsTypeCd == 'Prepared' || _ctx.dataset.dsTypeCd == 'Derived'
                  }, null, 8, ["style", "options", "modelValue", "class", "onChange", "disabled"]),
                  _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('managers.datasetManagement.selectDatasetType')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.dataset.dsTypeCd,
                  additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.datasetManagement.selectDatasetType')
                        }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ])
            ]),
            _: 1
          })
        ])),
    (_ctx.dataset.dsTypeCd == 'File')
      ? (_openBlock(), _createBlock(_component_FileDataset, {
          key: 2,
          selectedDataset: _ctx.selectedDataset,
          onFileUploaded: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('fileUploaded')))
        }, null, 8, ["selectedDataset"]))
      : (_ctx.dataset.dsTypeCd == 'Query')
        ? (_openBlock(), _createBlock(_component_QueryDataset, {
            key: 3,
            selectedDataset: _ctx.selectedDataset,
            dataSources: _ctx.dataSources,
            scriptTypes: _ctx.scriptTypes,
            activeTab: _ctx.activeTab,
            onQueryEdited: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('queryEdited')))
          }, null, 8, ["selectedDataset", "dataSources", "scriptTypes", "activeTab"]))
        : (_ctx.dataset.dsTypeCd == 'Java Class')
          ? (_openBlock(), _createBlock(_component_JavaDataset, {
              key: 4,
              selectedDataset: _ctx.selectedDataset
            }, null, 8, ["selectedDataset"]))
          : (_ctx.dataset.dsTypeCd == 'Script')
            ? (_openBlock(), _createBlock(_component_ScriptDataset, {
                key: 5,
                selectedDataset: _ctx.selectedDataset,
                scriptTypes: _ctx.scriptTypes,
                activeTab: _ctx.activeTab
              }, null, 8, ["selectedDataset", "scriptTypes", "activeTab"]))
            : (_ctx.dataset.dsTypeCd == 'Qbe' || _ctx.dataset.dsTypeCd == 'Federated')
              ? (_openBlock(), _createBlock(_component_QbeDataset, {
                  key: 6,
                  selectedDataset: _ctx.selectedDataset,
                  businessModels: _ctx.businessModels,
                  dataSources: _ctx.dataSources,
                  parentValid: _ctx.parentValid
                }, null, 8, ["selectedDataset", "businessModels", "dataSources", "parentValid"]))
              : (_ctx.dataset.dsTypeCd == 'Derived')
                ? (_openBlock(), _createBlock(_component_DerivedDataset, {
                    key: 7,
                    selectedDataset: _ctx.selectedDataset,
                    parentValid: _ctx.parentValid
                  }, null, 8, ["selectedDataset", "parentValid"]))
                : (_ctx.dataset.dsTypeCd == 'Flat')
                  ? (_openBlock(), _createBlock(_component_FlatDataset, {
                      key: 8,
                      selectedDataset: _ctx.selectedDataset,
                      dataSources: _ctx.dataSources
                    }, null, 8, ["selectedDataset", "dataSources"]))
                  : (_ctx.dataset.dsTypeCd == 'Ckan')
                    ? (_openBlock(), _createBlock(_component_CkanDataset, {
                        key: 9,
                        selectedDataset: _ctx.selectedDataset
                      }, null, 8, ["selectedDataset"]))
                    : (_ctx.dataset.dsTypeCd == 'REST')
                      ? (_openBlock(), _createBlock(_component_RestDataset, {
                          key: 10,
                          selectedDataset: _ctx.selectedDataset
                        }, null, 8, ["selectedDataset"]))
                      : (_ctx.dataset.dsTypeCd == 'SPARQL')
                        ? (_openBlock(), _createBlock(_component_SparqlDataset, {
                            key: 11,
                            selectedDataset: _ctx.selectedDataset
                          }, null, 8, ["selectedDataset"]))
                        : (_ctx.dataset.dsTypeCd == 'Solr')
                          ? (_openBlock(), _createBlock(_component_SolrDataset, {
                              key: 12,
                              selectedDataset: _ctx.selectedDataset
                            }, null, 8, ["selectedDataset"]))
                          : (_ctx.dataset.dsTypeCd == 'Python/R')
                            ? (_openBlock(), _createBlock(_component_PythonDataset, {
                                key: 13,
                                selectedDataset: _ctx.selectedDataset,
                                pythonEnvironments: _ctx.pythonEnvironments,
                                rEnvironments: _ctx.rEnvironments
                              }, null, 8, ["selectedDataset", "pythonEnvironments", "rEnvironments"]))
                            : _createCommentVNode("", true),
    (_ctx.dataset.dsTypeCd && _ctx.dataset.dsTypeCd != 'File' && _ctx.dataset.dsTypeCd != 'Flat' && _ctx.dataset.dsTypeCd != 'Prepared' && _ctx.dataset.dsTypeCd != 'Derived')
      ? (_openBlock(), _createBlock(_component_ParamTable, {
          key: 14,
          selectedDataset: _ctx.selectedDataset
        }, null, 8, ["selectedDataset"]))
      : _createCommentVNode("", true)
  ], 64))
}